"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "StepNoticeType", {
    enumerable: true,
    get: function() {
        return StepNoticeType;
    }
});
const StepNoticeType = {
    Info: 'info',
    Warning: 'warning',
    Danger: 'danger',
    Safety: 'safety'
};

//# sourceMappingURL=step-notice-type.js.map